import React, { Component, lazy } from 'react';

import { InputBlock, InputBlockIcon } from 'components/input';
import { I18n } from 'components/translate';
import withSuspense from 'hoc/withSuspense';
import PropTypes from 'prop-types';

const ContentEditorUploadWrapper = withSuspense(
  lazy(() => import('components/editor/ContentUploadWrapper'))
);

class InputGroup extends Component {
  static propTypes = {
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.string,
    maxLength: PropTypes.number,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    labelValue: PropTypes.string,
    submitted: PropTypes.bool
  };

  static defaultProps = {
    maxLength: 16383
  };

  render() {
    const {
      autoComplete,
      description,
      labelValue,
      maxLength,
      name,
      onChange,
      submitted,
      type,
      value,
      ...props
    } = this.props;

    const InputBlockComponent = this.props.icon ? InputBlockIcon : InputBlock;

    return (
      <InputBlockComponent
        name={name}
        labelValue={labelValue}
        submitted={submitted}
        maxLength={maxLength}
        {...props}
      >
        {description && (
          <p className="secondary">
            <I18n label={description} />
          </p>
        )}

        <ContentEditorUploadWrapper
          id={name}
          autoComplete={autoComplete}
          maxLength={maxLength}
          name={name}
          onChange={onChange}
          type={type}
          value={value}
          {...props}
        />
      </InputBlockComponent>
    );
  }
}

export default InputGroup;
